import { useTranslation } from 'react-i18next'
import { DevStatusPill } from '~/components/DevStatusPill'
import Spinner from '~/components/Spinner'
import { useAuth } from '~/helpers/store/auth'
import KnownOrgGate from '~/pages/authentication/find-organization/KnownOrgGate'
import Login from '~/pages/authentication/Login'

function App() {
  const { isLoading: authLoading, payload } = useAuth()
  const { t } = useTranslation()

  return (
    <div className="relative min-h-dvh w-full">
      {authLoading
        ? (
            <div className="flex min-h-dvh flex-col items-center justify-center gap-4">
              <Spinner className="size-8" />
              <p aria-hidden>
                {t('common.loading')}
                ...
              </p>
            </div>
          )
        : !payload
            ? <KnownOrgGate><Login /></KnownOrgGate>
            : null}

      <DevStatusPill />
    </div>
  )
}

export default App
